const About = () => {
  return (
    <div>
      <h1>About Page</h1>
      <p>About us content here</p>
    </div>
  );
};

export default About;
